module.exports = __webpack_public_path__ + "static/media/pieceEuro1.8c68beba.webp";